<template>
    <transition mode="out-in" name="fade">
    <div class="container-fluid touch-page competition-view" v-if="show">
        <div class="inline100">
            <div class="dflex">
                <router-link class="btn btn-big" to="/competitions">Back</router-link>
                <h1>Competition: {{name}}</h1>
                <router-link class="btn btn-big" to="/">Home Page</router-link>
            </div>


            <div v-html="html"></div>
            <transition mode="out-in" name="fade">
                <a id="js-btn-pageTop" class="btn-pageTop" @click="goToTop" v-if="showGoToTop">
                    <img class="img-fluid" src="/static/img/arrow-up.png"></a>
            </transition>
        </div>
    </div>
        <div v-else>
            <div class="loader" id="loader-1"></div>
        </div>
    </transition>
</template>
<script>
    import axios from 'axios'
    export default{
        props:['id'],
        data(){
            return{
                name: null,
                html: null,
                show: false,
                showGoToTop: false
            }
        },
        mounted() {
            axios.get('/ajax.php?q=getCompetitionView&id=' + this.id )
            .then(res => {
                this.name = res.data.name;
                this.html = res.data.html;
                this.show = true;
            })
            .catch(error => console.log(error))
        },
        methods:{
            goToTop(){
            window.scrollTo({
                top:0,
                behavior: 'smooth'
                })
                this.showGoToTop = false;
            },
            handleScroll(event){
                this.showGoToTop = true;
            }
        },
        created () {
            window.addEventListener('scroll', this.handleScroll);
        },
        destroyed () {
            window.removeEventListener('scroll', this.handleScroll);
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Competitions/View.vue